import { Box } from '@mui/material';
import { memo, useMemo } from 'react';
import { parseFormattedText, renderFormattedText } from '../../utils/parseFormattedText';

interface IGuideTextProps {
  text: string;
}

function GuideText({ text }: IGuideTextProps): JSX.Element {
  // 전체 텍스트를 파싱하고 렌더링 (줄바꿈 포함)
  const renderContent = useMemo(() => {
    const parsedNodes = parseFormattedText(text);
    return renderFormattedText(parsedNodes);
  }, [text]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        fontSize: { xs: '16px', sm: '22px' },
        fontWeight: 700,
        padding: { xs: '8px', sm: '16px' },
        paddingTop: 'env(safe-area-inset-top, 8px)',
      }}
    >
      <Box
        sx={{
          fontSize: { xs: '16px', sm: '22px' },
          fontWeight: 480,
          whiteSpace: 'pre-line',
          lineHeight: { xs: 1.4, sm: 1.6 },
        }}
      >
        {renderContent}
      </Box>
    </Box>
  );
}

export default memo(GuideText);
